<template>
    <div class="user-center">
        <Loading v-if="!loading"/>
        <div class="user-center-top" v-if="loading">
            <div class="user-avatar">
                <img :src="userInfo&&userInfo.icon" alt="">
            </div>
            <div class="user-name"><div class="user-name-text">{{userInfo&&userInfo.real_name?userInfo.real_name:'待完善'}}<span class="authen-tag" v-if="userInfo&&userInfo.real_name_auth==1">已认证</span></div></div>
            <p class="user-name" v-if="userInfo.white_info.is_vip" style="color:#FFCC33">VIP</p>
			<p class="authen-date" v-if="userInfo.white_info.date">{{userInfo.white_info.type&&userInfo.white_info.type}}有效期至{{userInfo.white_info.date&&userInfo.white_info.date.substring(0,10)}}</p>
            <div class="top-bottom">
                <div class="my-script-follow-box">
                    <router-link :to="{name:'myscriptlist'}">
                        <div class="my-script">
                            <p class="num">{{userInfo&&userInfo.my_article_count}}</p>
                            <p class="text">我的剧本</p>
                        </div>
                    </router-link>
                    <router-link :to="{name:'followlist'}">
                        <div class="my-follow">
                            <p class="num">{{userInfo&&userInfo.my_follow_count}}</p>
                            <p class="text">我的关注</p>
                        </div>
                    </router-link>
                </div>
                <router-link :to="{name:'authen'}"><div class="authen-btn"><span>实名认证</span>></div></router-link>
            </div>
        </div>
        <div class="user-center-href-list"  style="margin-bottom:4px;">
            <router-link :to="{name:'userinfo'}">
                <div class="href-btn">
                    <span>个人资料</span>
                    <span><van-icon name="arrow"/></span>
                </div>
            </router-link>
        </div>
        <div class="user-center-href-list msg-center-href" style="margin-bottom:4px;">
            <router-link :to="{name:'msgcenter'}">
                <div class="href-btn">
                    <span>消息中心<span class="new-msg-tag" v-if="hasUnreadMsg>=0"></span></span>
                    <span><van-icon name="arrow"/></span>
                </div>
            </router-link>
        </div>
        <div class="user-center-href-list">
            <router-link :to="{name:'feedback'}">
                <div class="href-btn">
                    <span>意见反馈</span>
                    <span><van-icon name="arrow"/></span>
                </div>
            </router-link>
        </div>
        <div class="user-center-href-list">
            <router-link :to="{name:'invitecode'}">
                <div class="href-btn">
                    <span>邀请码</span>
                    <span><van-icon name="arrow"/></span>
                </div>
            </router-link>
        </div>
		<div class="user-center-href-list">
            <router-link :to="{name:'security'}">
                <div class="href-btn">
                    <span>安全中心</span>
                    <span><van-icon name="arrow"/></span>
                </div>
            </router-link>
        </div>
		<div class="user-center-href-list">
            <router-link :to="{name:'help'}">
                <div class="href-btn">
                    <span>帮助中心</span>
                    <span><van-icon name="arrow"/></span>
                </div>
            </router-link>
        </div>
    </div>    
</template>

<script>
import {Axios} from '@/assets/api/axios'
import Loading from '@/components/Loading'
export default {
    name:'UserCenter',
    data(){
        return{
            userInfo:'',                         //储存用户信息
			loading:false,                       //控制加载页面显示隐藏
			msgStatusArr:[],                     //储蓄消息状态
			hasUnreadMsg:''                      //判断是否有未读消息
        }
    },
    created(){
		//获取个人信息
        Axios.get('/user/info').then(
            response=>{
                if(response.data.code==200&&response.data.status=="success"){
                    this.userInfo=response.data.data
					this.loading=true
					console.log('userinfo',this.userInfo)
                }
            }
        ).catch(
            error=>{
                console.log(error)
            }
		)
		//读取未读消息
		Axios.get('/user/message',{params:{page:0,num:20}})
		.then(
			response=>{
				if(response.data.code==200&&response.data.status=="success"){
					for(let i=0;i<response.data.data.lists.length;i++){
						this.msgStatusArr.push(response.data.data.lists[i].status)
					}
					this.hasUnreadMsg=this.msgStatusArr.indexOf(0)
				}
			}
		)
    },
    components:{
        Loading
    }
}
</script>

<style lang="scss" scoped>
    .user-center{
        width:750px;
        padding-top:118px;
        background:#F8F6F7;
        .user-center-top{
            padding:30px 44px;
            background:#f8f6f7;
            .user-avatar{
                width:140px;
                height:140px;
                margin:0 auto;
                margin-bottom:30px;
                img{
                    width:100%;
					height:100%;
                }
            }
            .user-name{
                font-size:32px;
                height:34px;
                color:#222;
                font-weight:bold;
                margin-bottom:16px;
                text-align:center;
                position:relative;
                .authen-tag{
                    position:absolute;
                    top:0;
                    margin-left:10px;
                    display:inline-block;
                    width:76px;
                    padding:5px 0;
                    border:1px solid #bf0000;
                    border-radius:35px;
                    text-align:center;
                    font-size:20px;
                    color:#bf0000;
                }
            }
            .authen-date{
                font-size:24px;
                height:24px;
                color:#999;
                text-align:center;
                margin-bottom:30px;
            }
            .top-bottom{
                height:74px;
                .my-script-follow-box{
                    width:476px;
                    height:74px;
                    margin-right:10px;
                    display:inline-block;
                    background:#fff;
                    .my-script,.my-follow{
                        display:inline-block;
                        text-align:center;
                        width:238px;
                        padding:13px 0;
                        position:relative;
                        .num{
                            font-size:24px;
                            color:#222;
                            font-weight:bold;
                            height:26px;
                            margin-bottom:4px;
                        }
                        .text{
                            font-size:20px;
                            color:#222;
                        }
                    }
                    .my-script::before{
                        content:'';
                        width:2px;
                        height:20px;
                        background:#ccc;
                        position:absolute;
                        right:-1px;
                        top:50%;
                        margin-top:-10px;
                    }
                }
                .authen-btn{
                    display:inline-block;
                    height:74px;
                    line-height:74px;
                    font-size:24px;
                    width:176px;
                    text-align:center;
                    background:#bf0000;
                    color:#fff;
                    vertical-align:top;
                    span{
                        margin-right:10px;
                    }
                }
                .authen-btn:active{
                    background:#DD8080;
                }
            }
        }
        .user-center-href-list{
            height:110px;
            background:#fff;
            .href-btn{
                height:28px;
                line-height:28px;
                padding:44px 36px;
                overflow:hidden;
                span{
                    font-size:26px;
                    color:#222;
                    font-weight:bold;
                }
                span:nth-of-type(1){
                    float:left;
                }
                span:nth-of-type(2){
                    float:right;
                }
            }
        }
		.msg-center-href{
			position:relative;
			.new-msg-tag{
				width:14px;
				height:14px;
				border-radius:50%;
				background:#bf0000;
				position:absolute;
				top:40px;
			}
		}
    }
</style>